import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { QueryBuilderConfig } from 'app/plugins/queryBuilder';
import { RuleBuilderService, EmptyRuleBuilder } from 'app/infrastructure/services/ruleBuilder.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { FieldMap } from 'app/plugins/queryBuilder/components';
import { ReportConfigurationColumn } from 'app/infrastructure/model/interfaces/reportConfiguration.interface';
import { TypeOptions, OperationPrototypes } from 'app/infrastructure/model/interfaces/rulePrototype.interface';
import { ReportConfigurationService } from 'app/infrastructure/services/reportConfiguration.service';

@Component({
    selector: 'sx-mappingDetails-reportconfiguration',
    templateUrl: './mappingDetails.reportconfiguration.component.html',
})
export class MappingDetailsReportConfigurationComponent implements OnInit {
    systemCode: string;
    businessCode: string;
    reportCode: string;
    mappingId: string;

    reportConfigConst = 'productReportConfigurationColumn';
    newConst = 'new';

    attributeModel:
        ReportConfigurationColumn = {
            id: null,
            systemCode: '',
            businessCode: '',
            description: '',
            reportCode: '',
            attribute: '',
            columnType: 'CUSTOM',
            type: 'string',
            mappingRule: '',
            reportConfigurationId: ''
        };

    // data types
    opciones = TypeOptions;
    sources = [];

    targetKeys = [];
    targetFields = [];

    isNew = false;
    selectedSource = 'documentAttribute';
    operationTypes = OperationPrototypes;
    mapperFields: FieldMap = null;
    loaded = false;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private reportConfigService: ReportConfigurationService,
        private location: Location,
        private alertService: AlertService,
        private ruleService: RuleBuilderService
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.businessCode = params['codnegocio'];
            this.reportCode = params['codreporte'];
            this.mappingId = params['mappingId'];

            this.ruleService.getForBusinessReportConfigurationColumn(this.systemCode, this.businessCode, this.reportCode)
                .subscribe(config => {
                    const ff = config.fields;   
                    this.sources = Object.keys(config.entities);
                    this.mapperFields = ff;
                    if (this.mappingId !== this.newConst) {
                        this.isNew = false;
                        if(!this.systemCode && !this.businessCode) {
                            this.reportConfigService
                            .getColumn(this.reportCode, this.mappingId)
                            .subscribe(data => {
                                this.attributeModel = data;
                                this.loaded = true;
                            });
                        } else {
                            this.reportConfigService
                            .getColumnByContex(this.systemCode,this.businessCode, this.reportCode, this.mappingId)
                            .subscribe(data => {
                                this.attributeModel = data;
                                this.loaded = true;
                            });
                        }
         
                    } else {
                        this.isNew = true;
                        this.attributeModel.systemCode = this.systemCode;
                        this.attributeModel.businessCode = this.businessCode;
                        this.attributeModel.reportConfigurationId = this.reportCode;
                        this.loaded = true;
                    }
                });
        });
    }

    back(): void {
        this.location.back();
    }

    save(): void {
        this.reportConfigService.saveColumn(this.attributeModel).then(a => {
            this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'OUTPUT_ATTRIUBUTE_SUCCESS',
            }, { name: a.attribute });
            this.back();
        });
    }

    getChange(event) {
        this.attributeModel.mappingRule = event;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/reportConfiguration/mapping/mappingDetails.reportconfiguration.component.ts